import { c as _c } from "react/compiler-runtime";
import { palette } from '@cc-shopping/ui/theme';
import { ButtonBase, Typography } from '@mui/material';
type Props = {
  disabled?: boolean;
  fontSize?: `${number}px`;
  onClick: () => void;
  shouldHideCloseIcon?: boolean;
};
export function Pill(t0) {
  const $ = _c(17);
  const {
    children,
    disabled: t1,
    fontSize: t2,
    onClick,
    shouldHideCloseIcon: t3
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const fontSize = t2 === undefined ? "12px" : t2;
  const shouldHideCloseIcon = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== disabled) {
    t4 = disabled && {
      backgroundColor: "#EBEBEC",
      opacity: 0.4
    };
    $[0] = disabled;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t4) {
    t5 = {
      backgroundColor: "neutral.lightest",
      borderRadius: "99px",
      paddingX: "0.75rem",
      width: "fit-content",
      paddingY: 1,
      ...t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== fontSize) {
    t6 = {
      color: "text.secondary",
      fontSize,
      fontWeight: 500
    };
    $[4] = fontSize;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== t6) {
    t7 = <Typography variant="text" sx={t6}>{children}</Typography>;
    $[6] = children;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== shouldHideCloseIcon) {
    t8 = !shouldHideCloseIcon && <span className="mask-icon mask-icon-close" style={{
      width: "16px",
      height: "16px",
      backgroundColor: palette.text.secondary,
      marginLeft: "4px"
    }} />;
    $[9] = shouldHideCloseIcon;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== disabled || $[12] !== onClick || $[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
    t9 = <ButtonBase disableRipple={true} disabled={disabled} onClick={onClick} sx={t5}>{t7}{t8}</ButtonBase>;
    $[11] = disabled;
    $[12] = onClick;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}